import { Component, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { DAO } from 'src/app/modal/DAO';
import { Constants } from 'src/app/modal/ProjConstants.models';
import { QuestionAnswer, Questionnaire } from 'src/app/modal/questionnaire.models';
import { ProductService } from 'src/app/services/product.service';

@Component({
    selector: 'no-fault',
    templateUrl: './no-fault.component.html',
    styleUrls: ['./no-fault.component.css']
})
export class NoFaultComponent implements OnInit, OnChanges {

    @Input() questionnaire: Questionnaire;
    @Input() isFormSubmitted: boolean;
    @Input() nfPipDed: String;

    public Q_addedPIP: QuestionAnswer; // Do you want Added Personal Injury Protection?
    public addedPIP: QuestionAnswer; // Added Personal Injury Protection
    public addedPIPDed: QuestionAnswer; // Added Personal Injury Protection Deductibles
    public insured_wc: QuestionAnswer; // Is insured covered by Workers Compensation?
    public lossOfIncomeBenefits: QuestionAnswer; // Does the applicant wish to exclude Loss of Income Benefits from No-Fault/PIP Coverages?
    public extendedPip: QuestionAnswer; //Does the applicant want Extended Personal Injury Protection?
    public excludeCoverageForWorkLoss: QuestionAnswer; //Does the applicant want to exclude coverage for Work Loss?
    public pipWorkLoss: QuestionAnswer; //PIP Work Loss Exclusion Applies
    public pipDedAppliesTo: QuestionAnswer; //PIP Deductible Applies
    public tortLimitSelectionListener?: () => void;
    public accountLegalEntityAnswer: string;
    public tortLimits: QuestionAnswer;

  constructor(private dao: DAO, private eventRenderer: Renderer2, private productService: ProductService) { }

    public ngOnInit(): void {
        this.loadQuestionAnswers();
      let eventListenerId = document.getElementById("tortLimitSelectYes");
      if (!!eventListenerId) {
        this.tortLimitSelectionListener = this.eventRenderer.listen(eventListenerId,
          this.productService.TORT_LIMIT_SELECTED,
          (event) => {
            if (!!event.detail) {
              // if the tort limits question is answered as REJECT, then reset the answer of 'insured_wc'
              if (event.detail == "No") {
                this.insured_wc.answer = ""
              }
            }
          });
      }
    }
    private loadQuestionAnswers(): void {
        var defaultQuestionAnswer = this.getDefaultQuestionAnswer();
        this.Q_addedPIP = this.questionnaire.questionAnswer.find(x => x.key === 'Q_addedPIP') ?? defaultQuestionAnswer;
        this.addedPIP = this.questionnaire.questionAnswer.find(x => x.key === 'addedPIP') ?? defaultQuestionAnswer;
        this.addedPIPDed = this.questionnaire.questionAnswer.find(x => x.key === 'addedPIPDed') ?? defaultQuestionAnswer;
        this.insured_wc = this.questionnaire.questionAnswer.find(x => x.key === 'insured_wc') ?? defaultQuestionAnswer;
        this.lossOfIncomeBenefits = this.questionnaire.questionAnswer.find(x => x.key === 'lossOfIncomeBenefits') ?? defaultQuestionAnswer;
        this.extendedPip = this.questionnaire.questionAnswer.find(x => x.key === 'extendedPip') ?? defaultQuestionAnswer;
        this.excludeCoverageForWorkLoss = this.questionnaire.questionAnswer.find(x => x.key === 'excludeCoverageForWorkLoss') ?? defaultQuestionAnswer;
        this.pipWorkLoss = this.questionnaire.questionAnswer.find(x => x.key === 'pipWorkLoss') ?? defaultQuestionAnswer;
        this.pipDedAppliesTo = this.questionnaire.questionAnswer.find(x => x.key === 'pipDedAppliesTo') ?? defaultQuestionAnswer;
        this.tortLimits = this.questionnaire.questionAnswer.find(x => x.key === 'tortLimits') ?? defaultQuestionAnswer;
        this.accountLegalEntityAnswer = this.productService.getAccountLegalEntityAnswer();
    }
    private getDefaultQuestionAnswer(): QuestionAnswer {
        return {
            answer: null,
            enabled: false,
            required: false,
            group: null,
            hidden: false,
            key: null,
            isVehicleUpdatedbyVEH1: false,
            minimum: null,
            name: null,
            type: '',
            rowIndex: 0,
            questionOptions: []
        }
    }
  changePIPAnswers() {
    if (this.Q_addedPIP.answer == 'No') {
      this.addedPIP.answer = '';
      this.addedPIPDed.answer = '';
    }
  }

  public ngOnChanges(changes:SimpleChanges):void {
    this.ChangeExtendedPIPAnswers();
  }

  ChangeExtendedPIPAnswers(){
    if(this.extendedPip?.answer && this.nfPipDed != "FULL"){
      this.extendedPip.answer = "";
    }
  }

  public ngOnDestroy(): void {
    if (this.tortLimitSelectionListener)
      this.tortLimitSelectionListener();
  }

  /* 
   For below two functions KY state, the logic checks tort limits, LegalEntity type, and Version check;
    otherwise, it defaults to checking the ODM enable flag.
 */

  public get q_addedPIPEnabled(): boolean {
    let hasTortlimits: boolean = this.questionnaire.questionAnswer.some(x => x.key === 'tortLimits'); // tortLimits is only available to KY state
    if (!hasTortlimits) {
      //other than KY state
      return this.Q_addedPIP.enabled
    }
    else {
      if (this.accountLegalEntityAnswer != 'INDIVIDUAL') {
        return false;
      }
      if (this.tortLimits.questionOptions.some(x => x.label === this.productService.INSURED_AND_ALL_REGULAR_OPERATORS_ACCEPT_TORT_LIMITATION)) {
        return false;
      }
      else if (this.tortLimits.answer == this.tortLimits.questionOptions[1].value) {
        return true;
      }
      return false;
    }
  }

  public get addedPIPEnabled(): boolean {
    let hasTortlimits: boolean = this.questionnaire.questionAnswer.some(x => x.key === 'tortLimits'); // tortLimits is only available to KY state
    if (!hasTortlimits) {
      //other than KY state
      return this.addedPIP.enabled
    }
    else {
      if (this.accountLegalEntityAnswer != 'INDIVIDUAL') {
        return false;
      }
      if (this.tortLimits.questionOptions.some(x => x.label === this.productService.INSURED_AND_ALL_REGULAR_OPERATORS_ACCEPT_TORT_LIMITATION)) {
        return false;
      }
      else if (this.tortLimits.answer == this.tortLimits.questionOptions[1].value) {
        return true;
      }
      return false;
    }
  }

  public get showInsured_WC(): boolean {
    let hasTortlimits: boolean = this.questionnaire.questionAnswer.some(x => x.key === 'tortLimits'); // tortLimits is only available to KY state
    if (!hasTortlimits) {
      //other than KY state
      return this.insured_wc.enabled;
    }
    else {
      let tortLimitsQA: QuestionAnswer = this.questionnaire.questionAnswer.find(x => x.key === 'tortLimits');
      if (!tortLimitsQA.questionOptions.some(x => x.label == this.productService.INSURED_AND_ALL_REGULAR_OPERATORS_ACCEPT_TORT_LIMITATION)) {
        // old version
        return this.insured_wc.enabled;
      }
      else {
        // new version
        if (this.questionnaire.questionAnswer.find(x => x.key === 'tortLimitSelect').answer == "Yes") {
          return true;
        }
        return false;
      }
    }
  }
}